<template>
    <div>
        <div v-if="showTimer">
            <p>You can request a new activation link in {{ countdown }} seconds</p>
        </div>

        <div v-else>
            Didn't receive the activation email?
            <a href="javascript:void(0)" class="theme-color fw-bold" @click="resendEmail">Resend activation link</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showTimer: true,
            countdown: 60
        };
    },
    created() {
        this.startTimer();
    },
    methods: {
        startTimer() {
            this.showTimer = true;
            this.countdown = 60;
            this.countdownInterval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.countdownInterval);
                    this.showTimer = false;
                }
            }, 1000);
        },
        resendEmail() {
            this.startTimer();
            this.$emit('resend');
        }
    },
    beforeUnmount() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }
};
</script>
